import DeleteReferenceContentUI from "./DeleteReferenceContentUI";

import { Plugin } from "@ckeditor/ckeditor5-core";

export default class DeleteReferenceContent extends Plugin {
  static get pluginName() {
    return "DeleteReferenceContent";
  }

  static get requires() {
    return [DeleteReferenceContentUI];
  }
}
